import { Icon } from '@winnin/ds-icon'

import type { IZaiBackgroundNotificationViewProps } from './zai-background-notification.types'

import './zai-background-notification.styles.scss'

export const ZaiBackgroundNotificationView = ({
  title,
  message,
  onGoToThread,
  onClose,
}: IZaiBackgroundNotificationViewProps) => (
  <div role="button" tabIndex={0} className="Zai-toast" onClick={onGoToThread}>
    <p className="Zai-toast-message">
      <span className="Zai-toast-title">&quot;{title}&quot;</span> {message}
    </p>
    <button type="button" onClick={onClose} className="Zai-toast-close" aria-label="Fechar">
      <Icon name="x" width={10} height={10} />
    </button>
  </div>
)
